import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import resourcesToBackend from 'i18next-resources-to-backend';
export * from './useTranslation';
i18n.use(LanguageDetector)
    .use(initReactI18next)
    .use(
        // 资源加载器 动态
        resourcesToBackend((language, namespace) => {
            return import(
                /* webpackChunkName: "locale-[request]" */
                `./locales/${namespace}/${language}.json`
            );
        }),
    )
    .init({
        // resources,
        fallbackLng: 'en', // 默认语言
        debug: false,

        interpolation: {
            escapeValue: false, // React 已经处理了 XSS
        },

        detection: {
            order: ['localStorage', 'navigator', 'htmlTag'],
            caches: ['localStorage'],
            lookupLocalStorage: 'i18nextLng', // localStorage 中的键名
            // 强制检测结果必须是英文或中文，否则使用英文
            convertDetectedLanguage: (lng) => {
                if (lng === 'zh' || lng === 'zh-CN' || lng === 'zh-TW') {
                    return 'zh';
                }
                return 'en'; // 默认返回英文
            },
        },
    });

export default i18n;
